import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import i18next from 'i18next';

import AllPayBankBalance from './AllPayBankBalance';
import { getBank } from '../../../actions/bankBalance';
import LoadingLayer from '../../controls/LoadingLayer';
import { IsEnglish } from '../../../utils/language';
import { toDisplayDecimal, stringToBoolean } from '../../../utils';
import * as general from '../../../scripts/GeneralConst';
import styles from '../../../styles/bankBalance.module.css';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    divFilter: {
        position: 'fixed',
        display: 'flex',
        left: '10px',
        right: '10px',
        top: '100px',
        zIndex: '1',
        backgroundColor: '#ffffff'
    },
    divFormControl: {
        paddingBottom: '0px !important',
        textAlign: 'end',
        display: 'block !important'
    },
    divList: {
        paddingBottom: '5px',
        marginTop: '50px'
    },
    spanNewRow: {
        display: 'table'
    },
    spanLabel: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    spanValue: {
        marginLeft: '5px',
        fontSize: '14px'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function PayBankBalance(props) {
    const classes = useStyles();

    const [dataBank, setDataBank] = React.useState(null);
    const [lastDataBank, setLastDataBank] = React.useState(null);
    const [originalDataBank, setOriginalDataBank] = React.useState(null);
    const [originalLastDataBank, setOriginalLastDataBank] = React.useState(null);
    const [dataBankType, setDataBankType] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [showBankBalanceZero, setShowBankBalanceZero] = React.useState(true);
    const [isFirstLoad, setIsFirstLoad] = React.useState(true);
    const [isProcessing, setIsProcessing] = React.useState(true);

    const { isLoading, isFromBankBalanceMenu } = props;
    
    useEffect(() => {
        setShowBankBalanceZero(stringToBoolean(localStorage.getItem(general.PayBankBalanceZero), true));
    }, []);

    useEffect(() => {
        if (isFirstLoad === true) {
            loadData();
        } else {
            reloadFilteredData();
        }
    }, [showBankBalanceZero]);

    const loadData = () => {
        getBank().then((response) => {
            response = JSON.parse(response);
            let list = response.list;
            let lastList = response.lastList;

            setOriginalDataBank(list);
            setOriginalLastDataBank(lastList);

            list = filterBankBalanceZero(list);
            lastList = filterBankBalanceZero(lastList);

            setDataBank(list);
            setLastDataBank(lastList);
            setIsFirstLoad(false);
            setIsProcessing(false);

            if (isLoading !== undefined) {
                isLoading(false);
            }
        });
    }

    const reloadFilteredData = () => {
        const list = filterBankBalanceZero(originalDataBank);
        const lastList = filterBankBalanceZero(originalLastDataBank);

        setDataBank(list);
        setLastDataBank(lastList);
    }

    const filterBankBalanceZero = (list) => {
        const filteredList = showBankBalanceZero === true ? list : list.filter(x => x.balance > 0);

        return filteredList;
    }

    const handleClick = (bankId) => {
        setDataBankType(dataBank.filter(item => item.bankTypeId == bankId));
        setOpen(true);
    }

    const handleCloseClick = () => {
        setOpen(false);
    }

    const onChangeShowBalanceZero = (event) => {
        setShowBankBalanceZero(event.target.checked);
        localStorage.setItem(general.PayBankBalanceZero, event.target.checked)
    }

    return (
        <div id="divPayBankBalance" className={styles.rootPayBank}>
            <LoadingLayer isActive={isProcessing}>
                <div className={styles.konekCard}>
                    <div className={isFromBankBalanceMenu ? classes.divFilter : ''}>
                        <FormControl className={[styles.switchComponent, classes.divFormControl].join(' ')}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={showBankBalanceZero}
                                        onChange={onChangeShowBalanceZero}
                                        name="showBankBalanceZero"
                                        variant="success"
                                    />
                                }
                                label={i18next.t("bankBalance:form.showBankBalanceZero")}
                                labelPlacement="start"
                            />
                        </FormControl>
                    </div>
                    <div className={isFromBankBalanceMenu ? classes.divList : ''}>
                        {lastDataBank != null && lastDataBank.map((obj, index) =>
                            <React.Fragment key={index}>
                                <ListItem key={index} button className="listItem" onClick={() => handleClick(obj.bankTypeId)}>
                                    <ListItemText disableTypography={true} primary={
                                        <React.Fragment>
                                            <div>
                                                <span className={classes.spanLabel}>{`${i18next.t('bankBalance:form.year')}${i18next.t('common:labelSeparator')}`}</span>
                                                <span className={classes.spanValue}>{obj.year}</span>
                                            </div>

                                            <div>
                                                <span className={classes.spanLabel}>{`${i18next.t('bankBalance:form.bank')}${i18next.t('common:labelSeparator')}`}</span>
                                                <span className={classes.spanValue}>{obj.bankTypeId + ' - ' + (IsEnglish() ? obj.bankEn : obj.bankFr)}</span>
                                            </div>

                                            <div>
                                                <span className={classes.spanLabel}>{`${i18next.t('bankBalance:form.bankBalance')}${i18next.t('common:labelSeparator')}`}</span>
                                                <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.balance))}</span>
                                            </div>

                                            <div>
                                                <span className={classes.spanLabel}>{`${i18next.t('bankBalance:form.provisionalUnitBalance')}${i18next.t('common:labelSeparator')}`}</span>
                                                <span className={classes.spanValue}>{toDisplayDecimal(parseFloat(obj.provisionalUnitBalance))}</span>
                                            </div>
                                        </React.Fragment>
                                    } />
                                </ListItem>
                            </React.Fragment>
                        )}
                    </div>

                    <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                        <div data-id="headerAllPayBankBalance">
                            <AppBar className={classes.appBar}>
                                <Toolbar>
                                    <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" className={classes.titleAppBarForm}>
                                        {i18next.t('bankBalance:title.bankPay')}
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                        </div>
                        <div data-id="detailAllPayBankBalance">
                            <AllPayBankBalance data={dataBankType}/>
                        </div>
                    </Dialog>
                </div>
            </LoadingLayer>
        </div>
    );
}